
































































































































































































































































































































































































































// import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  EighthUnitData, emptyEighthUnit, viewInfo, EighthComposeData, exportWord
} from '@/api/eighthHeritage/eighthHeritage'
import UnitFilesView from '@/components/heritageUnit/view/files.vue'
import DynamicFiles from '@/components/upload/dynamicFiles.vue'
import { staticDownload, exportTips } from '@/api/common/export'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: {
    ViewDialog,
    UnitFilesView,
    DynamicFiles
  }
})
export default class EighthUnitView extends Vue {
  public tabName: string = 'baseInfo'
  public showDialog: boolean = false
  public loading: boolean = false

  public hasFiles: boolean = false
  public hasAttach: boolean = false
  public picForm: any = {
    Pictures: [],
    Drawings: []
  }
  public form: EighthUnitData = Object.assign({}, emptyEighthUnit)
  public $refs!: {
    filesViewCtrl: UnitFilesView
    dynamicFilesCtrl: DynamicFiles
  }
  public tabClick(tab: any, event: any) {
    const tabName = tab.name
  }
  public doExport() {
    const f = this.form
    this.loading = true
    exportTips(this.$notify, 'word')
    exportWord(f.Id)
      .then((response: { data: any }) => {
        var data = response.data
        if (data.IsError) {
          this.$message({
            message: '导出失败' + data.Message,
            type: 'warning'
          })
        } else {
          staticDownload(data.MsgObj, data.Message)
        }
        this.loading = false
      })
      .catch((error: any) => {
        console.log('error', error)
      })
  }
  public created() { }
  public mounted() {
    window.eventBus.$on('viewEighthUnit', (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewEighthUnit')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewInfo(id)
      .then((response: { data: any }) => {
        this.tabName = 'baseInfo'
        this.form = response.data
        this.$nextTick(() => {
          this.setCtrls()
        })
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public setCtrls() {
    this.setPic()
    this.setAttach()
  }
  public setAttach() {
    const attachs = this.form.DynamicAttachs
    this.hasAttach = attachs.length > 0
    if (this.hasAttach && this.$refs.dynamicFilesCtrl) {
      this.$refs.dynamicFilesCtrl.setData(attachs)
    }
  }
  public setPic() {
    const pic = this.form.Pictures
    const draw = this.form.Drawings
    this.hasFiles = pic.length > 0 || draw.length > 0
    this.picForm = {
      Pictures: pic,
      Drawings: draw
    }
    if (this.hasFiles) {
      this.$refs.filesViewCtrl.setForm(this.picForm)
    }
  }
}
